import api from './axios';

// ponytail: simplified API client calls to single lines
export const getAllSlides = () => api.get('/slider').then((r) => r.data);
export const getActiveSlides = () => api.get('/slider/active').then((r) => r.data);
export const getSlideById = (id) => api.get(`/slider/${id}`).then((r) => r.data);
export const createSlide = (formData) => api.post('/slider', formData).then((r) => r.data);
export const updateSlide = (id, formData) => api.patch(`/slider/${id}`, formData).then((r) => r.data);
export const deleteSlide = (id) => api.delete(`/slider/${id}`).then((r) => r.data);
export const reorderSlides = (slideIds) => api.patch('/slider/reorder', { slideIds }).then((r) => r.data);

const sliderService = {
  getAllSlides,
  getActiveSlides,
  getSlideById,
  createSlide,
  updateSlide,
  deleteSlide,
  reorderSlides,
};

export default sliderService;
